// extracted by mini-css-extract-plugin
export default {"HolidaysItem":"HolidaysItem_HolidaysItem__KCGhR","grow":"HolidaysItem_grow__1Ve1t","isActive":"HolidaysItem_isActive__BCKbk"};